import { defineStore } from 'pinia'
import { CheckCenterAPI } from '@/services/checkCenter'
import { ref } from 'vue'
const getCurrentTime = () => {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}${m}${day}`
}
export const useCheckInCenterStore = defineStore('checkInCenter', () => {
  const taskList = ref<any[]>([])
  const days = ref<any[]>([])
  const isGetToday = ref()
  const getCheckInCenterList = async () => {
    const res = await CheckCenterAPI.getCurDate({
        curDate: Number(getCurrentTime())
    })
    taskList.value = res.data
  }
  const getSignInList = async () => {
    const res = await CheckCenterAPI.getSignInList({
      userDate: Number(getCurrentTime())
    })
    days.value = res.data.list
    isGetToday.value = res.data.isGetToday
  }
  return {
    isGetToday,
    days,
    taskList,
    getCheckInCenterList,
    getSignInList
  }
})
